export default __webpack_public_path__ + "static/media/Logo_Timevalue _transpa_sin_slogan.beed532f.png";